<section
    class="modal__details fade-in"
    [ngClass]="{
        'modal-mobile': isMobile,
        'modal-mobile-enter': isMobile && !isClosing,
        'modal-mobile-exit': isMobile && isClosing
    }"
>
    <div class="header" #header *ngIf="!isMobile">
        <div class="modal__title" *ngIf="!loadingList">
            <!-- Заказ №{{ pickedResearch.research_id }}  -->
            Материал: {{ reseachChild[0]?.specimen_text }}
            <div
                *ngIf="!isMobile"
                class="research-child-item__save"
                (click)="
                    goPdf(
                        pickedResearch.research_id,
                        $event,
                        pickedResearch.ext_results,
                        pickedResearch.internal_order
                    )
                "
            >
                <mat-icon
                    *ngIf="!isPdfLoading(pickedResearch.research_id)"
                    svgIcon="print"
                    class="cls-btn-print cls-btn-icon-print-custom"
                    alt="PdfLoading"
                ></mat-icon>
                <div
                    class="loader"
                    *ngIf="isPdfLoading(pickedResearch.research_id)"
                ></div>
                <!-- <img
                    *ngIf="!isPdfLoading(pickedResearch.research_id)"
                    class="pdf-loader loader-rotate"
                    src="./assets/img/svg/loader-btn.svg"
                    alt="PdfLoading"
                /> -->
            </div>
            <div
                *ngIf="isMobile"
                class="research-child-item__save"
                (click)="
                    goPdf(
                        pickedResearch.research_id,
                        $event,
                        pickedResearch.ext_results,
                        pickedResearch.internal_order
                    )
                "
            >
                <mat-icon
                    *ngIf="!isPdfLoading(pickedResearch.research_id)"
                    svgIcon="print"
                    class="cls-btn-print cls-btn-icon-print-custom"
                    alt="PdfLoading"
                ></mat-icon>
                <div
                    class="loader"
                    *ngIf="isPdfLoading(pickedResearch.research_id)"
                ></div>
                <!-- <img
                    *ngIf="isPdfLoading(pickedResearch.research_id)"
                    class="pdf-loader loader-rotate"
                    src="./assets/img/svg/loader-btn.svg"
                    alt="PdfLoading"
                /> -->
            </div>
        </div>

        <button
            class="modal__close"
            (click)="closeModal($event)"
            *ngIf="!isMobile"
        ></button>
    </div>
    <div class="modal__body" [class.closing]="isClosing" #modalBody>
        <div *ngIf="loadingList && !isMobile" class="loading-container">
            <loader type="page"></loader>
        </div>
        <div *ngIf="loadingList && isMobile" class="loader-mobile"></div>
        <div
            *ngIf="!reseachChild.length && loadingList"
            class="result-is-empty"
        >
            Нет данных
        </div>

        <!-- Mobile view for research blocks -->
        <ng-container *ngIf="isMobile" class="mobile-research-blocks">
            <ng-container *ngFor="let block of researchBlocks">
                <!-- <div class="mobile-research-block"> -->
                <!-- Block header if exists -->

                <!-- Mobile Results rows -->
                <ng-container *ngFor="let item of block.items; let i = index">
                    <!-- [ngClass]="{ 'mobile-even': i % 2 !== 0 }" -->
                    <div class="mobile-result-item">
                        <div
                            class="mobile-research__title"
                            *ngIf="i === 0 && block.title"
                        >
                            {{ block.title }}
                        </div>
                        <!-- Handle long text results differently in mobile -->
                        <ng-container
                            *ngIf="
                                item.text?.length > 20;
                                then mobileLongResult;
                                else mobileShortResult
                            "
                        ></ng-container>

                        <ng-template #mobileLongResult>
                            <div class="results__long">
                                <div class="mobile-result-header">
                                    <div class="mobile-measure">
                                        {{ item.measur }}
                                    </div>
                                    <div class="mobile-date">
                                        {{ item.resultdate }}
                                    </div>
                                </div>
                                <!-- <div class="mobile-text">{{ item.text }}</div> -->
                                <div
                                    class="mobile-text"
                                    [innerHTML]="item.text | htmlContent"
                                ></div>
                            </div>
                            <div
                                class="results__long__measure"
                                *ngIf="item.notes.length > 2"
                            >{{item.notes}}</div>
                        </ng-template>

                        <ng-template #mobileShortResult>
                            <div class="mobile-result-row">
                                <!-- Mobile table header shown once per block -->
                                <div
                                    class="mobile-table-header"
                                    *ngIf="block.showHeader"
                                >
                                    <div class="mobile-indicator-name">
                                        {{ item.measur }}
                                    </div>

                                    <div class="mobile-date">
                                        <!-- {{ item.resultdate }} -->
                                        <div class="mobile-status">
                                            <img
                                                *ngIf="item.dist.trim() !== ''"
                                                [ngClass]="{
                                                    rotate: isRotate(item.dist)
                                                }"
                                                src="./assets/img/lab/4.png"
                                                alt="arrow"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <!-- Result content -->
                                <div class="mobile-result-content">
                                    <!-- Parameter name and status indicator -->
                                    <div class="mobile-indicator">
                                        <div class="mobile-indicator-desc">
                                            <!-- <div>Откл.</div> -->
                                            <div>Результат</div>
                                            <div>Норма</div>
                                        </div>

                                        <div class="mobile-result-value">
                                            <!-- <div class="mobile-status">
                                                    <img
                                                        *ngIf="
                                                            item.dist.trim() !==
                                                            ''
                                                        "
                                                        [ngClass]="{
                                                            rotate: isRotate(
                                                                item.dist
                                                            )
                                                        }"
                                                        src="./assets/img/lab/4.png"
                                                        alt="arrow"
                                                    />
                                                </div> -->
                                            <div
                                                class="mobile-value"
                                                [ngClass]="{
                                                    'mobile-warning':
                                                        item.dist.trim()
                                                }"
                                            >
                                                <span
                                                    [innerHTML]="
                                                        item.text | htmlContent
                                                    "
                                                ></span>
                                                <span class="mobile-unit">{{
                                                    item.unit
                                                }}</span>
                                            </div>

                                            <div
                                                class="mobile-result-details"
                                                [innerHTML]="
                                                    item.norm_text | htmlContent
                                                "
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="results__long__measure"
                                *ngIf="item.notes.length > 2"
                            >{{item.notes}}</div>
                        </ng-template>
                    </div>
                </ng-container>
                <!-- </div> -->
            </ng-container>
        </ng-container>

        <!-- Desktop view for research blocks -->
        <ng-container *ngIf="!isMobile">
            <ng-container *ngFor="let block of researchBlocks">
                <div class="research-block">
                    <!-- Block header if exists -->
                    <div class="research__title">
                        <span *ngIf="block.title">{{ block.title }} </span>
                    </div>

                    <!-- Table header - shown only once at the top -->
                    <div class="description" *ngIf="block.showHeader">
                        <div
                            class="results__description-left results__description-title"
                        >
                            <div>Откл.</div>
                            <div>Показатель</div>
                        </div>
                        <div class="results__description-right">
                            <div>Результат</div>
                            <div>Норма</div>
                            <div>Дата</div>
                        </div>
                    </div>

                    <!-- Results rows -->
                    <ng-container
                        *ngFor="let item of block.items; let i = index"
                    >
                        <div
                            class="results"
                            [ngClass]="{
                                'long-result': item.text?.length > 20
                            }"
                        >
                            <ng-container
                                *ngIf="
                                    item.text?.length > 20;
                                    then LongResult;
                                    else shortResult
                                "
                            ></ng-container>

                            <ng-template #LongResult>
                                <div
                                    class="results__long-title"
                                    [ngClass]="{ 'bgc-even': i % 2 !== 0 }"
                                    *ngIf="
                                        item.measur.toLowerCase() !==
                                        'заключение'
                                    "
                                >
                                    <div></div>
                                    <div class="results__long__measure">
                                        {{ item.measur }}
                                    </div>
                                    <div class="mobile-result-details">
                                        {{ item.norm_text }}
                                    </div>
                                    <div class="results__long__date">
                                        {{ item.resultdate }}
                                    </div>
                                </div>
                                <div
                                    [class]="
                                        item.measur.toLowerCase() ===
                                        'заключение'
                                            ? 'results__long__measure'
                                            : 'longtext'
                                    "
                                    [innerHTML]="item.text | htmlContent"
                                ></div>
                            </ng-template>

                            <ng-template #shortResult>
                                <div
                                    class="results__description-left"
                                    [ngClass]="{ 'bgc-even': i % 2 !== 0 }"
                                >
                                    <div>
                                        <img
                                            *ngIf="item.dist.trim() !== ''"
                                            [ngClass]="{
                                                rotate: isRotate(item.dist)
                                            }"
                                            src="./assets/img/lab/4.png"
                                            alt="arrow"
                                        />
                                    </div>
                                    <div>{{ item.measur }}</div>
                                </div>
                                <div
                                    class="results__description-right items-start"
                                    [ngClass]="{ 'bgc-even': i % 2 !== 0 }"
                                >
                                    <div>
                                        <span
                                            class="value"
                                            [ngClass]="{
                                                warning: item.dist.trim()
                                            }"
                                            [innerHTML]="item.text | htmlContent"
                                            ></span
                                        >
                                        {{ item.unit }}
                                    </div>
                                    <div
                                        [innerHTML]="
                                            item.norm_text | htmlContent
                                        "
                                    ></div>
                                    <!-- <div>{{ item.norm_text }}</div> -->
                                    <div>{{ item.resultdate }}</div>
                                </div>
                            </ng-template>
                        </div>
                        <div
                            class="results__long__measure"
                            *ngIf="item.notes.length > 2"
                        >{{item.notes}}</div>
                    </ng-container>
                </div>
            </ng-container>
        </ng-container>
    </div>

    <!-- Mobile back button for easier navigation -->
    <!-- <div
        *ngIf="isMobile"
        class="mobile-back-button"
        (click)="closeModal($event)"
    >
        <span>Назад</span>
    </div> -->
</section>
